module.exports = __webpack_public_path__ + "static/media/wma.b072de5d.svg";